import { useEffect } from "react";

interface JsonLdProps {
  data: unknown;
}

const JsonLd = ({ data }: JsonLdProps) => {
  const json = JSON.stringify(data);

  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-darkskies-jsonld", "page");
    el.textContent = json;
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, [json]);

  return null;
};

export default JsonLd;
